module.exports = __webpack_public_path__ + "static/landing_subtitle-6007b67b26a99e55e80632dc7cdb9b3a.mp4";